var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v(_vm._s(_vm.payload.content))]),_c('a',{staticClass:"button is-info",on:{"click":_vm.activateCompanyEmployee}},[_vm._v("Activate Company Employee")])])
}
var staticRenderFns = []

export { render, staticRenderFns }